import { Box, Divider, Stack, Typography } from '@mui/material';
import classnames from 'classnames';

import { Icon } from '@/components/shared/icon';

import { getTestId } from './panelWrapper';

export interface PanelHeaderProps {
  onClose?: () => void;
  onBack?: () => void;
  hideBorder?: boolean;
  title: React.ReactNode;
  subtitle?: React.ReactNode;
  actions?: React.ReactNode;
  alignTitles?: boolean;
  testIdPrefix?: string;
  fullWidthSubtitle?: boolean;
}

export const PanelHeader = (props: PanelHeaderProps) => {
  const {
    title,
    subtitle,
    actions,
    testIdPrefix,
    onClose,
    onBack,
    hideBorder,
    alignTitles,
    fullWidthSubtitle = true,
  } = props;

  return (
    <Stack>
      <Stack
        justifyContent='space-between'
        direction='row'
        alignItems='center'
        padding='16px 24px'
      >
        <Stack
          alignItems='center'
          direction='row'
          className='flex-1'
          gap='12px'
        >
          {onBack && (
            <Icon
              data-testid='header-back-button'
              iconClass={`material-symbols-chevron-left-rounded`}
              className='cursor-pointer'
              onClick={onBack}
            />
          )}
          <Stack className='flex-1'>
            {typeof title === 'string' ? (
              <Typography
                variant='h3'
                data-testid={getTestId(testIdPrefix, 'side-panel-title')}
              >
                {title}
              </Typography>
            ) : (
              title
            )}
          </Stack>
        </Stack>
        <div className='flex gap-4 items-center'>
          {actions}
          {onClose && (
            <Icon
              onClick={onClose}
              iconClass='material-symbols-close-rounded'
              data-testid={getTestId(testIdPrefix, 'side-panel-close-button')}
            />
          )}
        </div>
      </Stack>
      {subtitle && (
        <Box
          className={classnames([
            {
              'ml-[24px]': alignTitles,
              'ml-[40px]': !alignTitles,
              'max-w-[580px]': !fullWidthSubtitle,
            },
            'mb-[20px] mt-[8px] mr-[24px]',
          ])}
        >
          {typeof subtitle === 'string' ? (
            <Typography variant='body1'>{subtitle}</Typography>
          ) : (
            subtitle
          )}
        </Box>
      )}
      {!hideBorder && <Divider />}
    </Stack>
  );
};
